import AxiosClient from "../../../services/axios.services";

class NotificationVariableServices {
  getNotificationVariable = (params) =>
    AxiosClient.get(
      "/api/app/notificacion_variable/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );


}

export default new NotificationVariableServices();
